module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grey--text"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.element.title))]), _vm._v(" "), _vm._l((_vm.upcomingDates), function(day) {
    return _c('div', {
      key: day.date,
      staticClass: "calendar-day display-flex"
    }, [_c('div', [_c('span', {
      staticStyle: {
        "margin-right": "15px",
        "font-size": "16px",
        "font-weight": "800",
        "color": "#bbb"
      }
    }, [_vm._v(_vm._s(day.weekday))]), _c('br'), _vm._v("\n            " + _vm._s(day.shortDate) + " "), _c('br')]), _vm._v(" "), _c('div', [_vm._l((day.events), function(event) {
      return _c('div', {
        key: event.key,
        staticClass: "mt-1 mr-1"
      }, [_c('Flag', {
        attrs: {
          "primary": ""
        }
      }, [_vm._v(_vm._s(event.title))])], 1)
    }), _vm._v(" "), _vm._l((day.tasks), function(task) {
      return _c('div', {
        key: task.key,
        staticClass: "mt-1 mr-1"
      }, [_c('flag', {
        staticStyle: {
          "max-width": "100%"
        }
      }, [_vm._v(_vm._s(task.title) + " (task)")])], 1)
    })], 2)])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-597e894a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ComingUp.vue
// module id = 2561
// module chunks = 1